





























import { computed, defineComponent, PropType } from "@vue/composition-api";
import { BlockedLocationAutocomplete } from "@scrile/api-provider/dist/api/BlockedLocationsProvider";
import { Gender } from "@scrile/api-provider/dist/api/UserProvider";
import { PreferredGender, RelationshipRole, UserLocation } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { getLocationName } from "@/lib/location";
import { ListFields } from "@/types";
import { genderNameMap, preferredGenderNameMap, relationshipRoleNameMap } from "@/const";
import LocationSearchInput from "@/components/LocationSearchInput";
import PublicInfoRadioGroup from "./components/PublicInfoRadioGroup.vue";

export default defineComponent({
  name: "PublicInfoEdit",
  components: {
    PublicInfoRadioGroup,
    LocationSearchInput,
  },
  props: {
    gender: { type: String as PropType<Gender>, required: true },
    preferredGender: { type: String as PropType<PreferredGender>, required: true },
    preferredPosition: { type: String as PropType<RelationshipRole>, required: true },
    location: { type: Object as PropType<UserLocation>, required: true },
    hideCreatorFields: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const locationName = computed(() => getLocationName(props.location));

    const genderValues: ListFields = [
      { text: genderNameMap[Gender.MALE], value: Gender.MALE },
      { text: genderNameMap[Gender.FEMALE], value: Gender.FEMALE },
      { text: genderNameMap[Gender.NON_BINARY], value: Gender.NON_BINARY },
    ];
    const preferredGenderValues: ListFields = [
      { text: preferredGenderNameMap[PreferredGender.MEN], value: PreferredGender.MEN },
      { text: preferredGenderNameMap[PreferredGender.WOMEN], value: PreferredGender.WOMEN },
      { text: preferredGenderNameMap[PreferredGender.NON_BINARY], value: PreferredGender.NON_BINARY },
    ];
    const preferredPositionValues: ListFields = [
      { text: relationshipRoleNameMap[RelationshipRole.TOP], value: RelationshipRole.TOP },
      { text: relationshipRoleNameMap[RelationshipRole.VERSATILE], value: RelationshipRole.VERSATILE },
      { text: relationshipRoleNameMap[RelationshipRole.BOTTOM], value: RelationshipRole.BOTTOM },
    ];

    const inputLocation = (value: BlockedLocationAutocomplete) => {
      emit("input:location", value);
    };

    const inputGender = (value: Gender) => {
      emit("input:gender", value ?? Gender.UNDEFINED);
    };

    const inputPreferredGender = (value: PreferredGender) => {
      emit("input:preferredGender", value ?? PreferredGender.UNDEFINED);
    };

    const inputPreferredPosition = (value: RelationshipRole) => {
      emit("input:preferredPosition", value ?? RelationshipRole.UNDEFINED);
    };

    return {
      locationName,
      genderValues,
      preferredGenderValues,
      preferredPositionValues,
      inputLocation,
      inputGender,
      inputPreferredGender,
      inputPreferredPosition,
    };
  },
});
